module.exports = "/static/assets/dccabc20e9265a2540b4fcb9e044f6ef.png";